'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _translate = require('../v2/language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable max-len */

function addNumericOptions($number) {
  var $options = [];
  for (var $i = 1; $i <= $number; $i++) {
    $options.push({
      value: $i,
      text: $i.toString()
    });
  }
  return $options;
}

function addIncrementalMoneyOptions($step, $max) {
  var $options = [];
  for (var $i = 0; $i <= $max; $i += $step) {
    $options.push({
      value: $i,
      text: '$ ' + Number($i).toLocaleString()
    });
  }
  return $options;
}

function getStandardRadioOptions() {
  return [{
    value: '1',
    text: (0, _translate.t)('Yes')
  }, {
    value: '0',
    text: (0, _translate.t)('No')
  }];
}

// Settings configured here will be merged into the final config object.
exports.default = {
  messages: {
    error_message: (0, _translate.t)('Please review your application as we found the following error(s)'),
    applicant_title: (0, _translate.t)('Applicant'),
    calculate_premium: (0, _translate.t)('Calculate Premium'),
    submit_application: (0, _translate.t)('Submit Application'),
    submit_questionnaire: (0, _translate.t)('Submit Questionnaire'),
    questionnaire_required: (0, _translate.t)('You will be required to fill a Medical Questionnaire attached in the Proposal document'),
    application_success: (0, _translate.t)('Your application has been submitted.'),
    questionnaire_success: (0, _translate.t)('Your questionnaire has been submitted.'),
    close: (0, _translate.t)('Close')
  },
  clients: {
    msh: {
      global2go: {
        product_name: 'Global2GO',
        form_header: (0, _translate.t)('Request to Quote Form'),
        questionnaire_header: (0, _translate.t)('Questionnaire Form'),
        form_config: [{
          header: (0, _translate.t)('Client Information'),
          active: true,
          fields: [{
            name: (0, _translate.t)('Canadian Client Name'),
            id: 'client_name',
            component_type: 'TextInputComponent',
            component_props: {
              type: 'text'
            },
            field_key: 'client_name'
          }, {
            name: (0, _translate.t)('What is the exact nature of business? (Please be specific)'),
            id: 'nature_of_business',
            component_type: 'TextInputComponent',
            component_props: {
              type: 'text'
            },
            field_key: 'nature_of_business'
          }, {
            name: (0, _translate.t)('Are your Canadian group benefits currently with Sun Life?'),
            id: 'currently_with_sunlife',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },

            field_key: 'currently_with_sunlife'
          }, {
            name: (0, _translate.t)('Account Executive Name'),
            id: 'account_executive_name',
            component_type: 'TextInputComponent',
            component_props: {
              type: 'text'
            },
            field_key: 'account_executive_name',
            show_if: [{
              key_path: 'currently_with_sunlife',
              value: ['1']
            }]
          }, {
            name: (0, _translate.t)('Account Executive Direct Phone Number'),
            id: 'account_executive_phone',
            component_type: 'TextInputComponent',
            component_props: {
              type: 'text'
            },
            field_key: 'account_executive_phone',
            show_if: [{
              key_path: 'currently_with_sunlife',
              value: ['1']
            }]
          }, {
            name: (0, _translate.t)('Sun Life Renewal Date'),
            id: 'renewal_date',
            component_type: 'DatePickerComponent',
            component_props: {
              placeholderText: (0, _translate.t)('Please select a date...'),
              showYearDropdown: true,
              showMonthDropdown: true,
              minDate: (0, _moment2.default)(),
              maxDate: (0, _moment2.default)().add(364, 'day')
            },
            field_key: 'renewal_date',
            show_if: [{
              key_path: 'currently_with_sunlife',
              value: ['1']
            }]
          }, {
            name: (0, _translate.t)('What benefits does Sun Life provide your group?'),
            id: 'sunlife_benefits',
            component_type: 'TextInputComponent',
            component_props: {
              type: 'text'
            },
            field_key: 'sunlife_benefits',
            show_if: [{
              key_path: 'currently_with_sunlife',
              value: ['1']
            }]
          }, {
            name: (0, _translate.t)('Are you considering moving your benefits plan to Sun Life?'),
            id: 'move_to_sunlife',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'move_to_sunlife',
            show_if: [{
              key_path: 'currently_with_sunlife',
              value: ['0']
            }]
          }, {
            name: (0, _translate.t)('Who is your Group Benefits Advisor (Advisor & Company Name)'),
            id: 'group_benefits_advisor',
            component_type: 'TextInputComponent',
            component_props: {
              type: 'text'
            },
            field_key: 'group_benefits_advisor'
          }, {
            name: (0, _translate.t)('Are Expatriate employees working on a rotational basis?'),
            id: 'rotational_basis',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'rotational_basis'
          }]
        }, {
          header: (0, _translate.t)('Coverage Information'),
          active: false,
          fields: [{
            name: (0, _translate.t)('Major Medical Insurance'),
            id: 'medical_coverage',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'medical_coverage',
            hasExpandableHint: true,
            expandableHintId: 'medicalCoverageHint',
            expandableHintPath: 'application.additional_data.medical_coverage',
            expandableHintIsRawHtml: false
          }, {
            name: (0, _translate.t)('Vision Care Benefit'),
            id: 'vision_coverage',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            show_if: [{
              key_path: 'medical_coverage',
              value: ['1']
            }],
            field_key: 'vision_coverage',
            hasExpandableHint: true,
            expandableHintId: 'visionCoverageHint',
            expandableHintPath: 'application.additional_data.vision_coverage',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Dental Insurance'),
            id: 'dental_coverage',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'dental_coverage',
            hasExpandableHint: true,
            expandableHintId: 'dentalCoverageHint',
            expandableHintPath: 'application.additional_data.dental_coverage',
            expandableHintIsRawHtml: false
          }, {
            name: (0, _translate.t)('Salary Based Benefits'),
            id: 'earnings',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'earnings'
          }, {
            name: (0, _translate.t)('Member Basic Life Insurance'),
            id: 'basic_life_insurance_multiplier',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'basic_life_insurance_multiplier',
            hasExpandableHint: true,
            expandableHintId: 'basic_life_insurance_multiplierCoverageHint',
            expandableHintPath: 'application.additional_data.basic_life_insurance_multiplier',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Basic Life Flat Benefit Amount'),
            id: 'basic_life_flat_benefit_amount',
            component_type: 'CurrencyInputComponent',
            component_props: {
              type: 'text',
              onChange: 'onChangeHook'
            },
            field_key: 'basic_life_flat_benefit_amount',
            show_if: [{
              key_path: 'basic_life_insurance_multiplier',
              value: ['flat']
            }],
            hasExpandableHint: true,
            expandableHintId: 'basic_life_flat_benefit_amountCoverageHint',
            expandableHintPath: 'application.additional_data.basic_life_flat_benefit_amount',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Voluntary Member and Spousal Life Insurance'),
            id: 'voluntary_life_insurance_amount',
            component_type: 'SelectComponent',
            component_props: {
              type: 'text',
              onChange: 'onChangeHook'
            },
            show_if: [{
              key_path: 'basic_life_insurance_multiplier',
              value: ['1', '2', '3', '4', '5', 'flat']
            }],
            field_key: 'voluntary_life_insurance_amount',
            hasExpandableHint: true,
            expandableHintId: 'voluntary_life_insurance_amountCoverageHint',
            expandableHintPath: 'application.additional_data.voluntary_life_insurance_amount',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Member AD&D'),
            id: 'adnd_insurance_multiplier',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'adnd_insurance_multiplier',
            hasExpandableHint: true,
            expandableHintId: 'adnd_insurance_multiplierCoverageHint',
            expandableHintPath: 'application.additional_data.adnd_insurance_multiplier',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('AD&D Flat Benefit Amount'),
            id: 'adnd_insurance_flat_benefit_amount',
            component_type: 'CurrencyInputComponent',
            component_props: {
              type: 'text',
              onChange: 'onChangeHook'
            },
            field_key: 'adnd_insurance_flat_benefit_amount',
            show_if: [{
              key_path: 'adnd_insurance_multiplier',
              value: ['flat']
            }]
          }, {
            name: (0, _translate.t)('Voluntary Member AD&D'),
            id: 'voluntary_adnd_insurance_amount',
            component_type: 'SelectComponent',
            component_props: {
              type: 'text',
              onChange: 'onChangeHook'
            },
            show_if: [{
              key_path: 'adnd_insurance_multiplier',
              value: ['1', '2', '3', '4', '5', 'flat']
            }],
            field_key: 'voluntary_adnd_insurance_amount',
            hasExpandableHint: true,
            expandableHintId: 'voluntary_adnd_insurance_amountCoverageHint',
            expandableHintPath: 'application.additional_data.voluntary_adnd_insurance_amount',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Temporary Total Disability / Weekly Disability'),
            id: 'temporary_disability',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'temporary_disability'
          }, {
            name: (0, _translate.t)('Temporary Total Disability Benefit Duration'),
            id: 'temporary_disability_benefit_duration',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'temporary_disability_benefit_duration',
            show_if: [{
              key_path: 'temporary_disability',
              value: ['1']
            }]
          }, {
            name: (0, _translate.t)('Temporary Total Disability Schedule Options'),
            id: 'temporary_disability_schedule_options',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'temporary_disability_schedule_options',
            show_if: [{
              key_path: 'temporary_disability',
              value: ['1']
            }]
          }, {
            name: (0, _translate.t)('Temporary Total Disability Weekly Benefit Maximum'),
            id: 'temporary_disability_weekly_maximum',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'temporary_disability_weekly_maximum',
            show_if: [{
              key_path: 'temporary_disability',
              value: ['1']
            }]
          }, {
            name: (0, _translate.t)('Long Term Disability'),
            id: 'long_term_disability',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('Yes')
              }, {
                value: 0,
                text: (0, _translate.t)('No')
              }],
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'long_term_disability',
            hasExpandableHint: true,
            expandableHintId: 'long_term_disabilityCoverageHint',
            expandableHintPath: 'application.additional_data.long_term_disability',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Long Term Disability Elimination Period'),
            id: 'long_term_disability_elimination_period',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'long_term_disability_elimination_period',
            show_if: [{
              key_path: 'long_term_disability',
              value: ['1']
            }]
          }, {
            name: (0, _translate.t)('Long Term Disability Schedule Options'),
            id: 'long_term_disability_schedule_options',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'long_term_disability_schedule_options',
            show_if: [{
              key_path: 'long_term_disability',
              value: ['1']
            }]
          }, {
            name: (0, _translate.t)('Permanent Total Disability'),
            id: 'permanent_total_disability_multiplier',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'permanent_total_disability_multiplier',
            hasExpandableHint: true,
            expandableHintId: 'permanent_total_disability_multiplierCoverageHint',
            expandableHintPath: 'application.additional_data.permanent_total_disability_multiplier',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Emergency Evacuation'),
            id: 'evacuation',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('Yes')
              }, {
                value: 0,
                text: (0, _translate.t)('No')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'evacuation'
          }, {
            name: (0, _translate.t)('International Employee Assistance Program'),
            id: 'eap',
            component_type: 'SelectComponent',
            component_props: {
              onChange: 'onChangeHook'
            },
            field_key: 'eap'
          }, {
            name: (0, _translate.t)('Number of Applicants'),
            id: 'applicant_count',
            component_type: 'SelectComponent',
            component_props: {
              options: addNumericOptions(20),
              placeholder: 'Please select...',
              onChange: 'setMemberCount'
            },
            field_key: 'applicant_count'
          }]
        }],
        questionnaire: {
          form_config: [{
            header: (0, _translate.t)('Applicant Information'),
            fields: [{
              id: 'applicant_firstname',
              config_path: 'application.additional_data.applicant_firstname',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: 'applicant_firstname',
              size: 6
            }, {
              id: 'applicant_lastname',
              config_path: 'application.additional_data.applicant_lastname',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: 'applicant_lastname',
              size: 6
            }, {
              id: 'applicant_dob',
              config_path: 'application.additional_data.applicant_dob',
              component_type: 'StaticComponent',
              component_props: {},
              field_key: 'applicant_dob',
              show_if: [{
                key_path: 'applicant_type',
                value: ['Primary']
              }],
              size: 6,
              isStatic: true
            }, {
              id: 'applicant_dob',
              config_path: 'application.additional_data.applicant_dob',
              component_type: 'DatePickerComponent',
              component_props: {
                minDate: (0, _moment2.default)().subtract(70, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: 'applicant_dob',
              show_if: [{
                key_path: 'applicant_type',
                value: ['Dependent']
              }],
              size: 6
            }, {
              id: 'applicant_gender',
              config_path: 'application.additional_data.applicant_gender',
              component_type: 'SelectComponent',
              component_props: {
                defaultEnabled: true,
                options: [{
                  value: 'female',
                  text: (0, _translate.t)('Female')
                }, {
                  value: 'male',
                  text: (0, _translate.t)('Male')
                }]
              },
              field_key: 'applicant_gender',
              size: 6
            }, {
              id: 'applicant_relationshiptoprimary',
              config_path: 'application.additional_data.applicant_relationshiptoprimary',
              component_type: 'SelectComponent',
              component_props: {
                defaultEnabled: true,
                options: [{
                  value: 'spouse',
                  text: (0, _translate.t)('Spouse')
                }, {
                  value: 'child',
                  text: (0, _translate.t)('Child')
                }]
              },
              field_key: 'applicant_relationshiptoprimary',
              show_if: [{
                key_path: 'applicant_type',
                value: ['Dependent']
              }],
              size: 6
            }, {
              id: 'applicant_clientname',
              config_path: 'application.additional_data.applicant_clientname',
              component_type: 'StaticComponent',
              component_props: {},
              field_key: 'applicant_clientname',
              size: 6,
              isStatic: true
            }, {
              id: 'applicant_policy',
              config_path: 'application.additional_data.applicant_policy',
              component_type: 'StaticComponent',
              component_props: {},
              field_key: 'applicant_policy',
              size: 6,
              isStatic: true
            }]
          }, {
            header: (0, _translate.t)('Medical Information'),
            fields: [{
              id: '1a',
              config_path: 'application.additional_data.1a',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'number',
                min: 10
              },
              field_key: '1a', // -----remove this for all in livexpat
              size: 4
            }, {
              id: '1b',
              config_path: 'application.additional_data.1b',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'number'
              },
              field_key: '1b',
              size: 4
            }, {
              id: '2base',
              config_path: 'application.additional_data.2base',
              component_type: 'StaticComponent',
              component_props: {},
              field_key: '2base',
              size: 12
            }, {
              id: '2a',
              config_path: 'application.additional_data.2a',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2a',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2a_date',
              config_path: 'application.additional_data.2a_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2a_date',
              size: 8,
              show_if: [{
                key_path: '2a',
                value: ['1']
              }]
            }, {
              id: '2a_address',
              config_path: 'application.additional_data.2a_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2a_address',
              size: 4,
              show_if: [{
                key_path: '2a',
                value: ['1']
              }]
            }, {
              id: '2a_details',
              config_path: 'application.additional_data.2a_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2a_details',
              size: 4,
              show_if: [{
                key_path: '2a',
                value: ['1']
              }]
            }, {
              id: '2b',
              config_path: 'application.additional_data.2b',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2b',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2b_date',
              config_path: 'application.additional_data.2b_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2b_date',
              size: 8,
              show_if: [{
                key_path: '2b',
                value: ['1']
              }]
            }, {
              id: '2b_address',
              config_path: 'application.additional_data.2b_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2b_address',
              size: 4,
              show_if: [{
                key_path: '2b',
                value: ['1']
              }]
            }, {
              id: '2b_details',
              config_path: 'application.additional_data.2b_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2b_details',
              size: 4,
              show_if: [{
                key_path: '2b',
                value: ['1']
              }]
            }, {
              id: '2c',
              config_path: 'application.additional_data.2c',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2c',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2c_date',
              config_path: 'application.additional_data.2c_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2c_date',
              size: 8,
              show_if: [{
                key_path: '2c',
                value: ['1']
              }]
            }, {
              id: '2c_address',
              config_path: 'application.additional_data.2c_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2c_address',
              size: 4,
              show_if: [{
                key_path: '2c',
                value: ['1']
              }]
            }, {
              id: '2c_details',
              config_path: 'application.additional_data.2c_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2c_details',
              size: 4,
              show_if: [{
                key_path: '2c',
                value: ['1']
              }]
            }, {
              id: '2d',
              config_path: 'application.additional_data.2d',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2d',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2d_date',
              config_path: 'application.additional_data.2d_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2d_date',
              size: 8,
              show_if: [{
                key_path: '2d',
                value: ['1']
              }]
            }, {
              id: '2d_address',
              config_path: 'application.additional_data.2d_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2d_address',
              size: 4,
              show_if: [{
                key_path: '2d',
                value: ['1']
              }]
            }, {
              id: '2d_details',
              config_path: 'application.additional_data.2d_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2d_details',
              size: 4,
              show_if: [{
                key_path: '2d',
                value: ['1']
              }]
            }, {
              id: '2e',
              config_path: 'application.additional_data.2e',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2e',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2e_date',
              config_path: 'application.additional_data.2e_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2e_date',
              size: 8,
              show_if: [{
                key_path: '2e',
                value: ['1']
              }]
            }, {
              id: '2e_address',
              config_path: 'application.additional_data.2e_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2e_address',
              size: 4,
              show_if: [{
                key_path: '2e',
                value: ['1']
              }]
            }, {
              id: '2e_details',
              config_path: 'application.additional_data.2e_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2e_details',
              size: 4,
              show_if: [{
                key_path: '2e',
                value: ['1']
              }]
            }, {
              id: '2f',
              config_path: 'application.additional_data.2f',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2f',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2f_date',
              config_path: 'application.additional_data.2f_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2f_date',
              size: 8,
              show_if: [{
                key_path: '2f',
                value: ['1']
              }]
            }, {
              id: '2f_address',
              config_path: 'application.additional_data.2f_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2f_address',
              size: 4,
              show_if: [{
                key_path: '2f',
                value: ['1']
              }]
            }, {
              id: '2f_details',
              config_path: 'application.additional_data.2f_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2f_details',
              size: 4,
              show_if: [{
                key_path: '2f',
                value: ['1']
              }]
            }, {
              id: '2g',
              config_path: 'application.additional_data.2g',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2g',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2g_date',
              config_path: 'application.additional_data.2g_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2g_date',
              size: 8,
              show_if: [{
                key_path: '2g',
                value: ['1']
              }]
            }, {
              id: '2g_address',
              config_path: 'application.additional_data.2g_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2g_address',
              size: 4,
              show_if: [{
                key_path: '2g',
                value: ['1']
              }]
            }, {
              id: '2g_details',
              config_path: 'application.additional_data.2g_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2g_details',
              size: 4,
              show_if: [{
                key_path: '2g',
                value: ['1']
              }]
            }, {
              id: '2h',
              config_path: 'application.additional_data.2h',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2h',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2h_date',
              config_path: 'application.additional_data.2h_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2h_date',
              size: 8,
              show_if: [{
                key_path: '2h',
                value: ['1']
              }]
            }, {
              id: '2h_address',
              config_path: 'application.additional_data.2h_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2h_address',
              size: 4,
              show_if: [{
                key_path: '2h',
                value: ['1']
              }]
            }, {
              id: '2h_details',
              config_path: 'application.additional_data.2h_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2h_details',
              size: 4,
              show_if: [{
                key_path: '2h',
                value: ['1']
              }]
            }, {
              id: '2i',
              config_path: 'application.additional_data.2i',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2i',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2i_date',
              config_path: 'application.additional_data.2i_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2i_date',
              size: 8,
              show_if: [{
                key_path: '2i',
                value: ['1']
              }]
            }, {
              id: '2i_address',
              config_path: 'application.additional_data.2i_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2i_address',
              size: 4,
              show_if: [{
                key_path: '2i',
                value: ['1']
              }]
            }, {
              id: '2i_details',
              config_path: 'application.additional_data.2i_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2i_details',
              size: 4,
              show_if: [{
                key_path: '2i',
                value: ['1']
              }]
            }, {
              id: '2j',
              config_path: 'application.additional_data.2j',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2j',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2j_date',
              config_path: 'application.additional_data.2j_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2j_date',
              size: 8,
              show_if: [{
                key_path: '2j',
                value: ['1']
              }]
            }, {
              id: '2j_address',
              config_path: 'application.additional_data.2j_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2j_address',
              size: 4,
              show_if: [{
                key_path: '2j',
                value: ['1']
              }]
            }, {
              id: '2j_details',
              config_path: 'application.additional_data.2j_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2j_details',
              size: 4,
              show_if: [{
                key_path: '2j',
                value: ['1']
              }]
            }, {
              id: '2k',
              config_path: 'application.additional_data.2k',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2k',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2k_date',
              config_path: 'application.additional_data.2k_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2k_date',
              size: 8,
              show_if: [{
                key_path: '2k',
                value: ['1']
              }]
            }, {
              id: '2k_address',
              config_path: 'application.additional_data.2k_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2k_address',
              size: 4,
              show_if: [{
                key_path: '2k',
                value: ['1']
              }]
            }, {
              id: '2k_details',
              config_path: 'application.additional_data.2k_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2k_details',
              size: 4,
              show_if: [{
                key_path: '2k',
                value: ['1']
              }]
            }, {
              id: '2l',
              config_path: 'application.additional_data.2l',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2l',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2l_date',
              config_path: 'application.additional_data.2l_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2l_date',
              size: 8,
              show_if: [{
                key_path: '2l',
                value: ['1']
              }]
            }, {
              id: '2l_address',
              config_path: 'application.additional_data.2l_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2l_address',
              size: 4,
              show_if: [{
                key_path: '2l',
                value: ['1']
              }]
            }, {
              id: '2l_details',
              config_path: 'application.additional_data.2l_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2l_details',
              size: 4,
              show_if: [{
                key_path: '2l',
                value: ['1']
              }]
            }, {
              id: '2m',
              config_path: 'application.additional_data.2m',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '2m',
              size: 10,
              show_if: [{
                key_path: '2base',
                value: ['']
              }]
            }, {
              id: '2m_date',
              config_path: 'application.additional_data.2m_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '2m_date',
              size: 8,
              show_if: [{
                key_path: '2m',
                value: ['1']
              }]
            }, {
              id: '2m_address',
              config_path: 'application.additional_data.2m_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2m_address',
              size: 4,
              show_if: [{
                key_path: '2m',
                value: ['1']
              }]
            }, {
              id: '2m_details',
              config_path: 'application.additional_data.2m_details',
              component_type: 'TextAreaComponent',
              component_props: {
                type: 'text'
              },
              field_key: '2m_details',
              size: 4,
              show_if: [{
                key_path: '2m',
                value: ['1']
              }]
            }, {
              id: '3base',
              config_path: 'application.additional_data.3base',
              component_type: 'StaticComponent',
              component_props: {},
              field_key: '3base',
              size: 12
            }, {
              id: '3a',
              config_path: 'application.additional_data.3a',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'number'
              },
              field_key: '3a',
              size: 4
            }, {
              id: '3b',
              config_path: 'application.additional_data.3b',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'number'
              },
              field_key: '3b',
              size: 4
            }, {
              id: '3c',
              config_path: 'application.additional_data.3c',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'number'
              },
              field_key: '3c',
              size: 4
            }, {
              id: '3d',
              config_path: 'application.additional_data.3d',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '3d',
              size: 10
            }, {
              id: '3d_date',
              config_path: 'application.additional_data.3d_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '3d_date',
              size: 8,
              show_if: [{
                key_path: '3d',
                value: ['1']
              }]
            }, {
              id: '3d_address',
              config_path: 'application.additional_data.3d_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '3d_address',
              size: 4,
              show_if: [{
                key_path: '3d',
                value: ['1']
              }]
            }, {
              id: '3d_details',
              config_path: 'application.additional_data.3d_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '3d_details',
              size: 4,
              show_if: [{
                key_path: '3d',
                value: ['1']
              }]
            }, {
              id: '4a',
              config_path: 'application.additional_data.4a',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '4a',
              size: 10
            }, {
              id: '4a_date',
              config_path: 'application.additional_data.4a_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '4a_date',
              size: 8,
              show_if: [{
                key_path: '4a',
                value: ['1']
              }]
            }, {
              id: '4a_address',
              config_path: 'application.additional_data.4a_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '4a_address',
              size: 4,
              show_if: [{
                key_path: '4a',
                value: ['1']
              }]
            }, {
              id: '4a_details',
              config_path: 'application.additional_data.4a_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '4a_details',
              size: 4,
              show_if: [{
                key_path: '4a',
                value: ['1']
              }]
            }, {
              id: '4b',
              config_path: 'application.additional_data.4b',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '4b',
              size: 10
            }, {
              id: '4c',
              config_path: 'application.additional_data.4c',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '4c',
              size: 6,
              show_if: [{
                key_path: '4b',
                value: ['1']
              }]
            }, {
              id: '4d',
              config_path: 'application.additional_data.4d',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '4d',
              size: 6,
              show_if: [{
                key_path: '4b',
                value: ['1']
              }]
            }, {
              id: '4e',
              config_path: 'application.additional_data.4e',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '4e',
              size: 6,
              show_if: [{
                key_path: '4b',
                value: ['1']
              }]
            }, {
              id: '5a',
              config_path: 'application.additional_data.5a',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '5a',
              size: 10
            }, {
              id: '5b',
              config_path: 'application.additional_data.5b',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '5b',
              size: 8
            }, {
              id: '5c',
              config_path: 'application.additional_data.5c',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '5c',
              size: 4
            }, {
              id: '5d',
              config_path: 'application.additional_data.5d',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '5d',
              size: 4
            }, {
              id: '6base',
              config_path: 'application.additional_data.6base',
              component_type: 'StaticComponent',
              component_props: {},
              field_key: '6base',
              size: 12
            }, {
              id: '6a',
              config_path: 'application.additional_data.6a',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '6a',
              size: 10,
              show_if: [{
                key_path: '6base',
                value: ['']
              }]
            }, {
              id: '6a_date',
              config_path: 'application.additional_data.6a_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '6a_date',
              size: 8,
              show_if: [{
                key_path: '6a',
                value: ['1']
              }]
            }, {
              id: '6a_address',
              config_path: 'application.additional_data.6a_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '6a_address',
              size: 4,
              show_if: [{
                key_path: '6a',
                value: ['1']
              }]
            }, {
              id: '6a_details',
              config_path: 'application.additional_data.6a_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '6a_details',
              size: 4,
              show_if: [{
                key_path: '6a',
                value: ['1']
              }]
            }, {
              id: '6b',
              config_path: 'application.additional_data.6b',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '6b',
              size: 10,
              show_if: [{
                key_path: '6base',
                value: ['']
              }]
            }, {
              id: '6b_date',
              config_path: 'application.additional_data.6b_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '6b_date',
              size: 8,
              show_if: [{
                key_path: '6b',
                value: ['1']
              }]
            }, {
              id: '6b_address',
              config_path: 'application.additional_data.6b_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '6b_address',
              size: 4,
              show_if: [{
                key_path: '6b',
                value: ['1']
              }]
            }, {
              id: '6b_details',
              config_path: 'application.additional_data.6b_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '6b_details',
              size: 4,
              show_if: [{
                key_path: '6b',
                value: ['1']
              }]
            }, {
              id: '6c',
              config_path: 'application.additional_data.6c',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '6c',
              size: 10,
              show_if: [{
                key_path: '6base',
                value: ['']
              }]
            }, {
              id: '6c_date',
              config_path: 'application.additional_data.6c_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '6c_date',
              size: 8,
              show_if: [{
                key_path: '6c',
                value: ['1']
              }]
            }, {
              id: '6c_address',
              config_path: 'application.additional_data.6c_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '6c_address',
              size: 4,
              show_if: [{
                key_path: '6c',
                value: ['1']
              }]
            }, {
              id: '6c_details',
              config_path: 'application.additional_data.6c_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '6c_details',
              size: 4,
              show_if: [{
                key_path: '6c',
                value: ['1']
              }]
            }, {
              id: '7base',
              config_path: 'application.additional_data.7base',
              component_type: 'StaticComponent',
              component_props: {},
              field_key: '7base',
              size: 12
            }, {
              id: '7a',
              config_path: 'application.additional_data.7a',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '7a',
              size: 10,
              show_if: [{
                key_path: '7base',
                value: ['']
              }]
            }, {
              id: '7a_date',
              config_path: 'application.additional_data.7a_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '7a_date',
              size: 8,
              show_if: [{
                key_path: '7a',
                value: ['1']
              }]
            }, {
              id: '7a_address',
              config_path: 'application.additional_data.7a_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '7a_address',
              size: 4,
              show_if: [{
                key_path: '7a',
                value: ['1']
              }]
            }, {
              id: '7a_details',
              config_path: 'application.additional_data.7a_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '7a_details',
              size: 4,
              show_if: [{
                key_path: '7a',
                value: ['1']
              }]
            }, {
              id: '7b',
              config_path: 'application.additional_data.7b',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '7b',
              size: 10,
              show_if: [{
                key_path: '7base',
                value: ['']
              }]
            }, {
              id: '7b_date',
              config_path: 'application.additional_data.7b_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '7b_date',
              size: 8,
              show_if: [{
                key_path: '7b',
                value: ['1']
              }]
            }, {
              id: '7b_address',
              config_path: 'application.additional_data.7b_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '7b_address',
              size: 4,
              show_if: [{
                key_path: '7b',
                value: ['1']
              }]
            }, {
              id: '7b_details',
              config_path: 'application.additional_data.7b_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '7b_details',
              size: 4,
              show_if: [{
                key_path: '7b',
                value: ['1']
              }]
            }, {
              id: '7c',
              config_path: 'application.additional_data.7c',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '7c',
              size: 10,
              show_if: [{
                key_path: '7base',
                value: ['']
              }]
            }, {
              id: '7d',
              config_path: 'application.additional_data.7d',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'number'
              },
              field_key: '7d',
              size: 6,
              show_if: [{
                key_path: '7c',
                value: ['1']
              }]
            }, {
              id: '8a',
              config_path: 'application.additional_data.8a',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '8a',
              size: 10
            }, {
              id: '8a_date',
              config_path: 'application.additional_data.8a_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '8a_date',
              size: 8,
              show_if: [{
                key_path: '8a',
                value: ['1']
              }]
            }, {
              id: '8a_address',
              config_path: 'application.additional_data.8a_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '8a_address',
              size: 4,
              show_if: [{
                key_path: '8a',
                value: ['1']
              }]
            }, {
              id: '8a_details',
              config_path: 'application.additional_data.8a_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '8a_details',
              size: 4,
              show_if: [{
                key_path: '8a',
                value: ['1']
              }]
            }, {
              id: '9a',
              config_path: 'application.additional_data.9a',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '9a',
              size: 10
            }, {
              id: '9a_date',
              config_path: 'application.additional_data.9a_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '9a_date',
              size: 8,
              show_if: [{
                key_path: '9a',
                value: ['1']
              }]
            }, {
              id: '9a_address',
              config_path: 'application.additional_data.9a_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '9a_address',
              size: 4,
              show_if: [{
                key_path: '9a',
                value: ['1']
              }]
            }, {
              id: '9a_details',
              config_path: 'application.additional_data.9a_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '9a_details',
              size: 4,
              show_if: [{
                key_path: '9a',
                value: ['1']
              }]
            }, {
              id: '9b',
              config_path: 'application.additional_data.9b',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '9b',
              size: 10
            }, {
              id: '9b_date',
              config_path: 'application.additional_data.9b_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '9b_date',
              size: 8,
              show_if: [{
                key_path: '9b',
                value: ['1']
              }]
            }, {
              id: '9b_address',
              config_path: 'application.additional_data.9b_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '9b_address',
              size: 4,
              show_if: [{
                key_path: '9b',
                value: ['1']
              }]
            }, {
              id: '9b_details',
              config_path: 'application.additional_data.9b_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '9b_details',
              size: 4,
              show_if: [{
                key_path: '9b',
                value: ['1']
              }]
            }, {
              id: '10a',
              config_path: 'application.additional_data.10a',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '10a',
              size: 10,
              show_if: [{
                key_path: 'applicant_gender',
                value: ['female']
              }]
            }, {
              id: '10a_date',
              config_path: 'application.additional_data.10a_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)(),
                maxDate: (0, _moment2.default)().add(1, 'years'),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '10a_date',
              size: 8,
              show_if: [{
                key_path: '10a',
                value: ['1']
              }]
            }, {
              id: '10a_address',
              config_path: 'application.additional_data.10a_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '10a_address',
              size: 4,
              show_if: [{
                key_path: '10a',
                value: ['1']
              }]
            }, {
              id: '10a_details',
              config_path: 'application.additional_data.10a_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '10a_details',
              size: 4,
              show_if: [{
                key_path: '10a',
                value: ['1']
              }]
            }, {
              id: '10b',
              config_path: 'application.additional_data.10b',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions()
              },
              field_key: '10b',
              size: 10,
              show_if: [{
                key_path: 'applicant_gender',
                value: ['female']
              }]
            }, {
              id: '10b_date',
              config_path: 'application.additional_data.10b_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '10b_date',
              size: 8,
              show_if: [{
                key_path: '10b',
                value: ['1']
              }]
            }, {
              id: '10b_address',
              config_path: 'application.additional_data.10b_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '10b_address',
              size: 4,
              show_if: [{
                key_path: '10b',
                value: ['1']
              }]
            }, {
              id: '10b_details',
              config_path: 'application.additional_data.10b_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '10b_details',
              size: 4,
              show_if: [{
                key_path: '10b',
                value: ['1']
              }]
            }, {
              id: '11a',
              config_path: 'application.additional_data.11a',
              component_type: 'RadioGroupComponent',
              component_props: {
                options: getStandardRadioOptions(),
                numberpoint: '11 a'
              },
              field_key: '11a',
              size: 10
            }, {
              id: '11a_date',
              config_path: 'application.additional_data.11a_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                minDate: (0, _moment2.default)().subtract(10, 'years'),
                maxDate: (0, _moment2.default)(),
                showYearDropdown: true,
                showMonthDropdown: true
              },
              field_key: '11a_date',
              size: 8,
              show_if: [{
                key_path: '11a',
                value: ['1']
              }]
            }, {
              id: '11a_address',
              config_path: 'application.additional_data.11a_address',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '11a_address',
              size: 4,
              show_if: [{
                key_path: '11a',
                value: ['1']
              }]
            }, {
              id: '11a_details',
              config_path: 'application.additional_data.11a_details',
              component_type: 'TextInputComponent',
              component_props: {
                type: 'text'
              },
              field_key: '11a_details',
              size: 4,
              show_if: [{
                key_path: '11a',
                value: ['1']
              }]
            }]
          }, {
            header: (0, _translate.t)('Authorizations and Declarations'),
            fields: [{
              id: 'auth1',
              config_path: 'application.additional_data.auth1',
              component_type: 'CheckboxComponent',
              component_props: {},
              field_key: 'auth1',
              size: 11
            }, {
              id: 'auth2',
              config_path: 'application.additional_data.auth2',
              component_type: 'CheckboxComponent',
              component_props: {},
              field_key: 'auth2',
              size: 11
            }, {
              id: 'auth3',
              config_path: 'application.additional_data.auth3',
              component_type: 'CheckboxComponent',
              component_props: {},
              field_key: 'auth3',
              size: 11
            }, {
              id: 'auth4',
              config_path: 'application.additional_data.auth4',
              component_type: 'CheckboxComponent',
              component_props: {},
              field_key: 'auth4',
              size: 11
            }, {
              id: 'auth5',
              config_path: 'application.additional_data.auth5',
              component_type: 'CheckboxComponent',
              component_props: {},
              field_key: 'auth5',
              size: 11
            }]
          }, {
            header: (0, _translate.t)('Privacy: Protecting your personal information'),
            fields: [{
              id: 'privacy1',
              config_path: 'application.additional_data.privacy1',
              component_type: 'CheckboxComponent',
              component_props: {},
              field_key: 'privacy1',
              size: 11
            }, {
              id: 'privacy2',
              config_path: 'application.additional_data.privacy2',
              component_type: 'CheckboxComponent',
              component_props: {},
              field_key: 'privacy2',
              size: 11
            }]
          }, {
            header: (0, _translate.t)('Applicant Signature'),
            fields: [
            // {
            //   id: 'signature',
            //   config_path: 'application.additional_data.signature',
            //   component_type: 'TextInputComponent',
            //   component_props: {
            //     type: 'text',
            //     placeholderText: t('first name and last name')
            //   },
            //   field_key: 'signature',
            //   size: 6,
            // },
            {
              id: 'signature_date',
              config_path: 'application.additional_data.signature_date',
              component_type: 'DatePickerComponent',
              component_props: {
                placeholderText: (0, _translate.t)('Please select a date...'),
                showYearDropdown: true,
                showMonthDropdown: true,
                minDate: (0, _moment2.default)(),
                maxDate: (0, _moment2.default)()
              },
              field_key: 'signature_date',
              size: 6
            }]
          }]
        }
      },

      livexpat: {
        form_config: [{
          header: (0, _translate.t)('Coverage Information'),
          active: true,
          fields: [{
            name: (0, _translate.t)('Legal Company Name'),
            id: 'client_name',
            component_type: 'TextInputComponent',
            component_props: {
              type: 'text'
            },
            field_key: 'client_name',
            show_if: [{
              key_path: 'form_type',
              value: ['group']
            }]
          }, {
            name: (0, _translate.t)('Contract Situs'),
            id: 'contract_situs',
            component_type: 'SelectComponent',
            formConfigOptionSource: 'applicant.additional_data.home_country',
            component_props: {
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'contract_situs',
            show_if: [{
              key_path: 'form_type',
              value: ['group']
            }]
          }, {
            name: (0, _translate.t)('What is the exact nature of business? (Please specify industry)'),
            id: 'nature_of_business',
            component_type: 'TextInputComponent',
            component_props: {
              type: 'text'
            },
            field_key: 'nature_of_business',
            show_if: [{
              key_path: 'form_type',
              value: ['group']
            }]
          }, {
            name: (0, _translate.t)('Coverage Effective Date'),
            id: 'effective_date',
            component_type: 'DatePickerComponent',
            component_props: {
              placeholderText: (0, _translate.t)('Please select a date...'),
              showYearDropdown: true,
              showMonthDropdown: true,
              onChange: 'setExpiryDate',
              minDate: (0, _moment2.default)(),
              maxDate: (0, _moment2.default)().add(2, 'year')
            },
            field_key: 'effective_date'
          }, {
            name: (0, _translate.t)('Type of Medical Coverage'),
            id: 'medical_coverage_type',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 'emergency',
                text: (0, _translate.t)('Emergency')
              }, {
                value: 'comprehensive',
                text: (0, _translate.t)('Comprehensive')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'medical_coverage_type'
          }, {
            name: (0, _translate.t)('Emergency Medical Coverage'),
            id: 'emergency_coverage',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 'basic',
                text: (0, _translate.t)('Emergency')
              }, {
                value: 'plus',
                text: (0, _translate.t)('Emergency PLUS')
              }, {
                value: '0',
                text: (0, _translate.t)('N/A')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'emergency_coverage',
            show_if: [{
              key_path: 'coverage_duration',
              value: [1]
            }, {
              key_path: 'medical_coverage_type',
              value: ['emergency']
            }],
            hasExpandableHint: true,
            expandableHintId: 'emergencyCoverageHint',
            expandableHintPath: 'application.additional_data.emergency_coverage',
            expandableHintIsRawHtml: false
          }, {
            name: (0, _translate.t)('Comprehensive Medical Insurance'),
            id: 'medical_coverage',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 'livone',
                text: (0, _translate.t)('LivOne')
              }, {
                value: 'livtwo',
                text: (0, _translate.t)('LivTwo')
              }, {
                value: 'livthree',
                text: (0, _translate.t)('LivThree')
              }, {
                value: 'livfour',
                text: (0, _translate.t)('LivFour')
              }, {
                value: 'livfive',
                text: (0, _translate.t)('LivFive')
              }, {
                value: '0',
                text: (0, _translate.t)('N/A')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'medical_coverage',
            show_if: [{
              key_path: 'coverage_duration',
              value: [1]
            }, {
              key_path: 'medical_coverage_type',
              value: ['comprehensive']
            }],
            hasExpandableHint: true,
            expandableHintId: 'medicalCoverageHint',
            expandableHintPath: 'application.additional_data.medical_coverage',
            expandableHintIsRawHtml: false
          }, {
            name: (0, _translate.t)('Dental Insurance'),
            id: 'dental_coverage',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 'basic',
                text: (0, _translate.t)('Basic')
              }, {
                value: 'plus',
                text: (0, _translate.t)('Plus')
              }, {
                value: '0',
                text: (0, _translate.t)('N/A')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            show_if: [{
              key_path: 'coverage_duration',
              value: [1]
            }, {
              key_path: 'medical_coverage_type',
              value: ['comprehensive']
            }, {
              key_path: 'medical_coverage',
              value: ['livone', 'livtwo', 'livthree', 'livfour', 'livfive']
            }],
            field_key: 'dental_coverage',
            hasExpandableHint: true,
            expandableHintId: 'dentalCoverageHint',
            expandableHintPath: 'application.additional_data.dental_coverage',
            expandableHintIsRawHtml: false
          }, {
            name: (0, _translate.t)('Member Basic Life Insurance'),
            id: 'basic_life_insurance_multiplier',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('1 x Salary')
              }, {
                value: 2,
                text: (0, _translate.t)('2 x Salary')
              }, {
                value: 3,
                text: (0, _translate.t)('3 x Salary')
              }, {
                value: 4,
                text: (0, _translate.t)('4 x Salary')
              }, {
                value: 5,
                text: (0, _translate.t)('5 x Salary')
              }, {
                value: 'flat',
                text: (0, _translate.t)('Flat Benefit Amount')
              }, {
                value: 0,
                text: (0, _translate.t)('N/A')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            show_if: [{
              key_path: 'form_type',
              value: ['individual']
            }],
            field_key: 'basic_life_insurance_multiplier',
            hasExpandableHint: true,
            expandableHintId: 'basic_life_insurance_multiplierCoverageHint',
            expandableHintPath: 'application.additional_data.basic_life_insurance_multiplier',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Member Basic Life Insurance'),
            id: 'basic_life_insurance_multiplier',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('1 x Salary')
              }, {
                value: 2,
                text: (0, _translate.t)('2 x Salary')
              }, {
                value: 3,
                text: (0, _translate.t)('3 x Salary')
              }, {
                value: 4,
                text: (0, _translate.t)('4 x Salary')
              }, {
                value: 5,
                text: (0, _translate.t)('5 x Salary')
              }, {
                value: 'flat',
                text: (0, _translate.t)('Flat Benefit Amount')
              }, {
                value: 0,
                text: (0, _translate.t)('N/A')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            show_if: [{
              key_path: 'form_type',
              value: ['group']
            }],
            field_key: 'basic_life_insurance_multiplier',
            hasExpandableHint: true,
            expandableHintId: 'basic_life_insurance_multiplierCoverageHint',
            expandableHintPath: 'application.additional_data.basic_life_insurance_multiplier_group',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Basic Life Flat Benefit Amount'),
            id: 'basic_life_flat_benefit_amount',
            component_type: 'CurrencyInputComponent',
            component_props: {
              type: 'text',
              onChange: 'onChangeHook'
            },
            field_key: 'basic_life_flat_benefit_amount',
            show_if: [{
              key_path: 'basic_life_insurance_multiplier',
              value: ['flat']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }],
            hasExpandableHint: true,
            expandableHintId: 'basic_life_flat_benefit_amountCoverageHint',
            expandableHintPath: 'application.additional_data.basic_life_flat_benefit_amount',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Spousal Life Insurance'),
            id: 'spousal_life_insurance',
            component_type: 'SelectComponent',
            component_props: {
              options: addIncrementalMoneyOptions(5000, 500000),
              defaultEnabled: false,
              placeholder: 'Please select...',
              type: 'text',
              onChange: 'onChangeHook'
            },
            field_key: 'spousal_life_insurance',
            show_if: [{
              key_path: 'basic_life_insurance_multiplier',
              value: ['1', '2', '3', '4', '5', 'flat']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }],
            hasExpandableHint: false,
            expandableHintId: 'basic_life_insurance_multiplierCoverageHint',
            expandableHintPath: 'application.additional_data.basic_life_insurance_multiplier',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Dependent Child Life Insurance'),
            id: 'dependent_life_insurance',
            component_type: 'SelectComponent',
            component_props: {
              options: addIncrementalMoneyOptions(2500, 10000),
              defaultEnabled: false,
              placeholder: 'Please select...',
              type: 'text',
              onChange: 'onChangeHook'
            },
            field_key: 'dependent_life_insurance',
            show_if: [{
              key_path: 'basic_life_insurance_multiplier',
              value: ['1', '2', '3', '4', '5', 'flat']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }],
            hasExpandableHint: false,
            expandableHintId: 'basic_life_insurance_multiplierCoverageHint',
            expandableHintPath: 'application.additional_data.basic_life_insurance_multiplier',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Optional Life Insurance'),
            id: 'optional_life_insurance',
            component_type: 'SelectComponent',
            component_props: {
              options: addIncrementalMoneyOptions(20000, 500000),
              defaultEnabled: false,
              placeholder: 'Please select...',
              type: 'text',
              onChange: 'onChangeHook'
            },
            field_key: 'optional_life_insurance',
            show_if: [{
              key_path: 'form_type',
              value: ['group']
            }, {
              key_path: 'basic_life_insurance_multiplier',
              value: ['1', '2', '3', '4', '5', 'flat']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }],
            hasExpandableHint: false,
            expandableHintId: 'basic_life_insurance_multiplierCoverageHint',
            expandableHintPath: 'application.additional_data.basic_life_insurance_multiplier',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Member AD&D'),
            id: 'adnd_insurance_multiplier',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('1 x Salary')
              }, {
                value: 2,
                text: (0, _translate.t)('2 x Salary')
              }, {
                value: 3,
                text: (0, _translate.t)('3 x Salary')
              }, {
                value: 4,
                text: (0, _translate.t)('4 x Salary')
              }, {
                value: 5,
                text: (0, _translate.t)('5 x Salary')
              }, {
                value: 'flat',
                text: (0, _translate.t)('Flat Benefit Amount')
              }, {
                value: 0,
                text: (0, _translate.t)('N/A')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'adnd_insurance_multiplier',
            show_if: [{
              key_path: 'coverage_duration',
              value: [1]
            }],
            hasExpandableHint: true,
            expandableHintId: 'adnd_insurance_multiplierCoverageHint',
            expandableHintPath: 'application.additional_data.adnd_insurance_multiplier',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('AD&D Flat Benefit Amount'),
            id: 'adnd_insurance_flat_benefit_amount',
            component_type: 'CurrencyInputComponent',
            component_props: {
              type: 'text',
              onChange: 'onChangeHook'
            },
            field_key: 'adnd_insurance_flat_benefit_amount',
            show_if: [{
              key_path: 'adnd_insurance_multiplier',
              value: ['flat']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }]
          }, {
            name: (0, _translate.t)('Temporary Total Disability'),
            id: 'temporary_disability',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('Yes')
              }, {
                value: 0,
                text: (0, _translate.t)('No')
              }],
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'temporary_disability',
            show_if: [{
              key_path: 'form_type',
              value: ['individual']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }],
            hasExpandableHint: false
          }, {
            name: (0, _translate.t)('Temporary Total Disability'),
            id: 'temporary_disability',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('Yes')
              }, {
                value: 0,
                text: (0, _translate.t)('No')
              }],
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'temporary_disability',
            show_if: [{
              key_path: 'form_type',
              value: ['group']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }],
            hasExpandableHint: true,
            expandableHintId: 'temporary_disabilityCoverageHint',
            expandableHintPath: 'application.additional_data.temporary_disability_group',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Temporary Total Disability Benefit Duration'),
            id: 'temporary_disability_benefit_duration',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 90,
                text: (0, _translate.t)('90 day plan')
              }, {
                value: 180,
                text: (0, _translate.t)('180 day plan')
              }, {
                value: 365,
                text: (0, _translate.t)('365 day plan')
              }],
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'temporary_disability_benefit_duration',
            show_if: [{
              key_path: 'temporary_disability',
              value: ['1']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }]
          }, {
            name: (0, _translate.t)('Temporary Total Disability Schedule Options'),
            id: 'temporary_disability_schedule_options',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 60,
                text: (0, _translate.t)('60% of basic weekly earnings')
              }, {
                value: 66.67,
                text: (0, _translate.t)('66.67% of basic weekly earnings')
              }, {
                value: 70,
                text: (0, _translate.t)('70% of basic weekly earnings')
              }],
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'temporary_disability_schedule_options',
            show_if: [{
              key_path: 'temporary_disability',
              value: ['1']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }]
          }, {
            name: (0, _translate.t)('Temporary Total Disability Weekly Benefit Maximum'),
            id: 'temporary_disability_weekly_maximum',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1000,
                text: (0, _translate.t)('$1000')
              }, {
                value: 2000,
                text: (0, _translate.t)('$2000')
              }],
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'temporary_disability_weekly_maximum',
            show_if: [{
              key_path: 'temporary_disability',
              value: ['1']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }]
          }, {
            name: (0, _translate.t)('Long Term Disability'),
            id: 'long_term_disability',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('Yes')
              }, {
                value: 0,
                text: (0, _translate.t)('No')
              }],
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'long_term_disability',
            show_if: [{
              key_path: 'form_type',
              value: ['individual']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }],
            do_not_show_if: [{
              key_path: 'permanent_total_disability_multiplier',
              value: ['1', '2', '3', '4', '5', 'flat']
            }],
            hasExpandableHint: false
          }, {
            name: (0, _translate.t)('Long Term Disability'),
            id: 'long_term_disability',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('Yes')
              }, {
                value: 0,
                text: (0, _translate.t)('No')
              }],
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'long_term_disability',
            show_if: [{
              key_path: 'form_type',
              value: ['group']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }],
            do_not_show_if: [{
              key_path: 'permanent_total_disability_multiplier',
              value: ['1', '2', '3', '4', '5', 'flat']
            }],
            hasExpandableHint: true,
            expandableHintId: 'long_term_disabilityCoverageHint',
            expandableHintPath: 'application.additional_data.long_term_disability_group',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Long Term Disability Elimination Period'),
            id: 'long_term_disability_elimination_period',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 90,
                text: (0, _translate.t)('90 day plan')
              }, {
                value: 180,
                text: (0, _translate.t)('180 day plan')
              }],
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'long_term_disability_elimination_period',
            show_if: [{
              key_path: 'long_term_disability',
              value: ['1']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }]
          }, {
            name: (0, _translate.t)('Long Term Disability Schedule Options'),
            id: 'long_term_disability_schedule_options',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 60,
                text: (0, _translate.t)('60% of basic monthly earnings')
              }, {
                value: 66.67,
                text: (0, _translate.t)('66.67% of basic monthly earnings')
              }, {
                value: 70,
                text: (0, _translate.t)('70% of basic monthly earnings')
              }],
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'long_term_disability_schedule_options',
            show_if: [{
              key_path: 'long_term_disability',
              value: ['1']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }]
          }, {
            name: (0, _translate.t)('Permanent Total Disability'),
            id: 'permanent_total_disability_multiplier',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('1 x Salary')
              }, {
                value: 2,
                text: (0, _translate.t)('2 x Salary')
              }, {
                value: 3,
                text: (0, _translate.t)('3 x Salary')
              }, {
                value: 4,
                text: (0, _translate.t)('4 x Salary')
              }, {
                value: 5,
                text: (0, _translate.t)('5 x Salary')
              }, {
                value: 0,
                text: (0, _translate.t)('N/A')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'permanent_total_disability_multiplier',
            show_if: [{
              key_path: 'form_type',
              value: ['individual']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }],
            do_not_show_if: [{
              key_path: 'long_term_disability',
              value: ['1']
            }]
          }, {
            name: (0, _translate.t)('Permanent Total Disability'),
            id: 'permanent_total_disability_multiplier',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('1 x Salary')
              }, {
                value: 2,
                text: (0, _translate.t)('2 x Salary')
              }, {
                value: 3,
                text: (0, _translate.t)('3 x Salary')
              }, {
                value: 4,
                text: (0, _translate.t)('4 x Salary')
              }, {
                value: 5,
                text: (0, _translate.t)('5 x Salary')
              }, {
                value: 0,
                text: (0, _translate.t)('N/A')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'permanent_total_disability_multiplier',
            show_if: [{
              key_path: 'form_type',
              value: ['group']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }],
            do_not_show_if: [{
              key_path: 'long_term_disability',
              value: ['1']
            }],
            hasExpandableHint: true,
            expandableHintId: 'permanent_total_disability_multiplierCoverageHint',
            expandableHintPath: 'application.additional_data.permanent_total_disability_multiplier_group',
            expandableHintIsRawHtml: true
          }, {
            name: (0, _translate.t)('Evacuation & Repatriation'),
            id: 'evacuation',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 0,
                text: (0, _translate.t)('N/A')
              }, {
                value: 'low',
                text: (0, _translate.t)('Low Risk')
              }, {
                value: 'high',
                text: (0, _translate.t)('High Risk')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'evacuation',
            show_if: [{
              key_path: 'coverage_duration',
              value: [1]
            }, {
              key_path: 'medical_coverage_type',
              value: ['comprehensive']
            }]
          }, {
            name: (0, _translate.t)('International Employee Assistance Program'),
            id: 'eap',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('Yes')
              }, {
                value: 0,
                text: (0, _translate.t)('No')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'eap',
            show_if: [{
              key_path: 'form_type',
              value: ['group']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }]
          }, {
            name: (0, _translate.t)('Expatriate Support Program'),
            id: 'esp',
            component_type: 'SelectComponent',
            component_props: {
              options: [{
                value: 1,
                text: (0, _translate.t)('Yes')
              }, {
                value: 0,
                text: (0, _translate.t)('No')
              }],
              defaultEnabled: false,
              placeholder: 'Please select...',
              onChange: 'onChangeHook'
            },
            field_key: 'esp',
            show_if: [{
              key_path: 'form_type',
              value: ['individual']
            }, {
              key_path: 'coverage_duration',
              value: [1]
            }]
          }]
        }]
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/config/base.js
// module id = 1653
// module chunks = 0